// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_visible_pPnQBAC75CIhuX0pC0RP {
  display: block;
}

.style-module_hidden_yBPWnAHTM4RLpQovafSe {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ShowHideArea/style.module.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,aAAA;AACJ","sourcesContent":[".visible {\n    display: block;\n}\n\n.hidden {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visible": `style-module_visible_pPnQBAC75CIhuX0pC0RP`,
	"hidden": `style-module_hidden_yBPWnAHTM4RLpQovafSe`
};
export default ___CSS_LOADER_EXPORT___;
